export const routerGuide = [
  {
    path: '/guideDynamic',
    name: 'guideDynamic',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideDynamic/one.vue'),
  },
  {
    path: '/ysrGuideOne',
    name: 'ysrGuideOne',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideYsr/one.vue'),
  },
  {
    path: '/xdGuideOne',
    name: 'xdGuideOne',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideXd/one.vue'),
  },
  {
    path: '/xdGuideToStore',
    name: 'xdGuideToStore',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideXd/two.vue'),
  },
  {
    path: '/yrGuideOne',
    name: 'yrGuideOne',
    meta: {
      title: '悦融',
    },
    component: () => import('@/pages/guideYr/one.vue'),
  },
  {
    path: '/ysrGuideOneNo',
    name: 'ysrGuideOneNo',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideYsr/two.vue'),
  },
  {
    path: '/yrGuideTwo',
    name: 'yrGuideTwo',
    meta: {
      title: '悦融',
    },
    component: () => import('@/pages/guideYr/two.vue'),
  },
  {
    path: '/wbGuideOne',
    name: 'wbGuideOne',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideWb/one.vue'),
  },
  {
    path: '/yrjkGuideOne',
    name: 'yrjkGuideOne',
    meta: {
      title: '悦融借款',
    },
    component: () => import('@/pages/guideYrjk/one.vue'),
  },
  {
    path: '/guideToStoreBd',
    name: 'guideToStoreBd',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideBd/one.vue'),
  },
  {
    path: '/jlGuideOne',
    name: 'jlGuideOne',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideJl/one.vue'),
  },
  {
    path: '/jlGuideTwo',
    name: 'jlGuideTwo',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideJl/two.vue'),
  },
  {
    path: '/xdGuideOneTTN',
    name: 'xdGuideOneTTN',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guideXd239/one.vue'),
  },
  {
    path: '/xdGuideOne2541',
    name: 'xdGuideOne2541',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guide2541/one.vue'),
  },
  {
    path: '/xdGuideTwo2541',
    name: 'xdGuideTwo2541',
    meta: {
      title: '小荷花',
    },
    component: () => import('@/pages/guide2541/two.vue'),
  },
  {
    path: '/guideDLPageTwentySevenLogin',
    name: 'guideDLPageTwentySevenLogin',
    meta: {
      title: '小荷花',
    },
    component: () => import('../pages/guideDLPageTwentySevenLogin/login.vue'),
  },
  {
    path: '/guideDLPageTwentyLogin',
    name: 'guideDLPageTwentyLogin',
    meta: {
      title: '小荷花',
    },
    component: () => import('../pages/guideDLPageTwentyLogin/index.vue'),
  },
];
